type ButtonProps = React.ComponentProps<"button"> & {
    large?: boolean
    forwardRef?: React.LegacyRef<HTMLButtonElement>
}

export default function PrimaryButton({
    type = "button",
    className = "",
    disabled,
    children,
    forwardRef,
    ...props
}: ButtonProps) {
    return (
        <button
            {...props}
            ref={forwardRef}
            type={type}
            className={`
                text-md inline-flex content-center items-center justify-center
                rounded-3xl border border-transparent bg-bonza-primary px-4 py-2
                text-center text-bonza-pale transition duration-150 ease-in-out

                active:bg-bonza-pale active:text-bonza-dark

                disabled:bg-bonza-dark-semi

                focus:outline-none focus:ring-2 focus:ring-bonza-primary
                focus:ring-offset-2

                hover:bg-bonza-pale hover:text-bonza-dark

                ${disabled && "opacity-25"}
                ${className}
            `}
            disabled={disabled}
        >
            {children}
        </button>
    )
}

export function SecondaryButton({
    type = "button",
    className = "",
    disabled,
    children,
    ...props
}: ButtonProps) {
    return (
        <button
            {...props}
            type={type}
            className={`
                text-md inline-flex content-center items-center justify-center
                rounded-full bg-bonza-pale-t-7 px-4 py-2 text-center
                font-semibold text-bonza-pale transition duration-150
                ease-in-out

                active:bg-bonza-pale active:text-bonza-dark

                disabled:opacity-25

                focus:outline-none focus:ring-2 focus:ring-bonza-primary
                focus:ring-offset-2

                hover:bg-bonza-pale hover:text-bonza-dark

                ${disabled && "opacity-25"}
                ${className}
            `}
            disabled={disabled}
        >
            {children}
        </button>
    )
}

export function DangerButton({
    className = "",
    disabled,
    children,
    ...props
}: ButtonProps) {
    return (
        <button
            {...props}
            className={`
                text-md inline-flex content-center items-center justify-center
                rounded-full bg-red-500 px-4 py-2 text-center font-semibold
                text-bonza-pale transition duration-150 ease-in-out

                active:bg-red-300 active:text-bonza-dark

                disabled:opacity-25

                focus:outline-none focus:ring-2 focus:ring-red-500
                focus:ring-offset-2

                hover:bg-red-300 hover:text-bonza-dark

                ${disabled && "opacity-25"}
                ${className}
            `}
            disabled={disabled}
        >
            {children}
        </button>
    )
}
